// HEADER BUTTONS
const headerButtons = document.querySelectorAll(".header__buttons > [is=magnet-link]")
let hover = false;

if (headerButtons.length > 0) {
  headerButtons.forEach(btn => {
    btn.addEventListener("mouseenter", headerIconEnter)
    btn.addEventListener('mousemove', positionElement)
    btn.addEventListener("mouseleave", headerIconLeave)
  })
}
function headerIconEnter() {
  hover = true;
}
function headerIconLeave(e) {
  hover = false;

  const svg = e.target.querySelector("svg")
  svg.style.transform = "translate(0px, 0px)";
}
function positionElement(e) {
  const rect = e.target.getBoundingClientRect();
  const centerX = rect.width / 2;
  const centerY = rect.height / 2;
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  const offsetX = Math.min(Math.max(x - centerX, -6), 6);
  const offsetY = Math.min(Math.max(y - centerY, -6), 6);
  const svg = e.target.querySelector("svg")
  svg.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
}


// CUSTOM MENU DRAWER
const drawerButtons = document.querySelectorAll('*[drawer-controller]');

drawerButtons.forEach(btn => {
  btn.addEventListener('click', handleDrawer);
})

function handleDrawer(e) {
  const drawer = document.getElementById(e.target.getAttribute('aria-controls'));
  drawer.classList.toggle("active")
}

// SUBSCRIBE BUTTON

let buyNowProdCardTextContent = "";
const loop = document.querySelectorAll('input[name="loop_purchase_option"]')

if (loop.length > 0) {
  loop.forEach(el => {
    el.addEventListener("click", (e) => {
      let button;
      let buyButton;
      let cartButton;
    
      const prodCard = e.target.closest(".prod-card");
      
      if (prodCard) {
        const productId = prodCard.id.replace("prod-card-", "");
        button = prodCard.querySelector(`#prod-card-${productId} .buy-now-button .btn-text`);
    
        buyButton = prodCard.querySelector(`#prod-card-${productId} .buy-now-button`);
        cartButton = prodCard.querySelector(`#prod-card-${productId} button[type="submit"]`);
      } else {
        button = document.querySelector(".buy-now-button .btn-text");
      }
    
      if (e.target.dataset.name.toLowerCase().includes("subscribe")) {
        console.log(buyNowProdCardTextContent)
        if (buyNowProdCardTextContent === "") buyNowProdCardTextContent = button.innerText;
        if (buyButton) buyButton.classList.add("button-now-subscription");
        if (cartButton) cartButton.classList.add("cart-subscription");
    
        if (!window.location.pathname.includes("subscription")) {
          button.innerText = "SUBSCRIBE NOW";
        }
      } else if (buyNowProdCardTextContent !== "") {
        if (buyButton) buyButton.classList.remove("button-now-subscription");
        if (cartButton) cartButton.classList.remove("cart-subscription");
    
        button.innerText = buyNowProdCardTextContent;
        buyNowProdCardTextContent = "";
      }
    })
  })
}